import { render, staticRenderFns } from "./dxReel.vue?vue&type=template&id=061332d6&scoped=true&"
import script from "./dxReel.vue?vue&type=script&lang=js&"
export * from "./dxReel.vue?vue&type=script&lang=js&"
import style0 from "./dxReel.vue?vue&type=style&index=0&id=061332d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061332d6",
  null
  
)

export default component.exports